<template>
  <div class="document-upload">
    <c-uploader
      multiple
      ref="uploader"
      v-model="files"
      class="custom v-mt-lg"
      no-thumbnails
      hide-underline
      url=""
      method="PUT"
      :url-factory="getUploadURL"
      :upload-factory="uploadFile"
      :send-raw="true"
      :headers="{ authorization: 'Bearer ' + userToken }"
      @finish="uploaded"
      @batchFailed="batchFailed"
      v-on:passwordFailed="passwordFailed"
      @abort="aborted"
      :after="[]"
      :auto-expand="true"
      expand-class="files-to-upload"
      v-on:start="$emit('uploadStarted')"
      v-on:fileReadStart="$emit('fileReadStart')"
      v-on:fileReadStop="$emit('fileReadStop')"
      v-on:add="$emit('fileReadStop')"
      :secureToken="this.secureToken"
      :userToken="this.userToken"
      :isMobile="isMobile"
      @filesToUpload="files => $emit('filesToUpload', files)"
    />
  </div>
</template>

<script>
import CUploader from './uploader.vue'
import { Utils } from '../../ciitizen-component-library'

export default {
  name: 'documentUploader',
  components: {
    CUploader
  },
  data() {
    return {
      files: [],
      upload: {
        title: '',
        description: ''
      }
    }
  },
  props: ['secureUploadToken', 'userToken', 'isMobile'],
  computed: {
    secureToken() {
      if (this.secureUploadToken) {
        return this.secureUploadToken
      }
    }
  },
  methods: {
    getUploadURL: function (file) {
      if (file.__password && !file.password) {
        // No need to continue as file is password protected and password was not provide
        return
      }
      let payload = {
        title: this.upload.title || file.name,
        description: this.upload.description,
        filename: !file.isExtensionMissing ? file.name : file.name + '.' + file.fileExtension,
        // Using attributes to store password
        attributes: {
          password: file.password
        }
      }
      // check for secure upload:
      if (this.secureUploadToken) {
        // add headers:
        const requestOptions = {
          headers: { Authorization: 'Bearer ' + this.secureUploadToken }
        }
        return this.$http
          .post('/import', payload, requestOptions)
          .then(resp => {
            return Promise.resolve(resp.data.href)
          })
          .catch(e => {
            return Promise.reject(e)
          })
      }
      return new Promise((resolve, reject) => {
        this.$http
          .post('/file', payload)
          .then(resp => {
            resolve(resp.data.href)
          })
          .catch(reject)
      })
    },
    uploadFile(file, updateProgress) {
      // todo: move this whole function to c-uploader
      const xhr = new XMLHttpRequest()
      file.xhr = xhr
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        file.__inProgress = true // todo: define initial value in init function
        xhr.upload.addEventListener(
          'progress',
          e => {
            if (file.__removed) {
              return
            }
            e.percent = e.total ? e.loaded / e.total : 0
            let uploaded = e.percent * file.size
            this.uploadedSize += uploaded - file.__uploaded
            file.__uploaded = uploaded
            file.__progress = Math.min(99, parseInt(e.percent * 100, 10))
            updateProgress(e.percent)
          },
          false
        )
        xhr.onreadystatechange = () => {
          if (xhr.readyState < 4) {
            return
          }
          if (xhr.status && xhr.status < 400) {
            file.__inProgress = false
            file.__doneUploading = true
            file.__progress = 100
            resolve(file)
          } else {
            file.__inProgress = false
            file.__failed = true
            reject(xhr)
          }
        }
        xhr.onerror = () => {
          file.__inProgress = false
          file.__failed = true
          // this.$emit('fail', file, xhr)
          reject(xhr)
        }
        xhr.onabort = () => {
          file.__inProgress = false
          file.__failed = true
          file.__aborted = true
          reject(xhr)
        }
        xhr.ontimeout = () => {
          file.__inProgress = false
          file.__failed = true
          file.__timedOut = true
          reject(xhr)
        }
        try {
          if (!file.uploadURL) {
            file.uploadURL = await this.getUploadURL(file)
          }
        } catch (err) {
          file.__inProgress = false
          file.__failed = true
          reject(xhr)
        }
        // We should only do upload if a valid URL is present,right?
        if (file.uploadURL) {
          try {
            xhr.open('PUT', file.uploadURL, true)
            xhr.setRequestHeader('authorization', 'Bearer ' + this.secureToken)
            // If browser doesn't detect file type then try to detect from ext
            // This fixes the case of uploading dicom files from a windows machine not working
            xhr.setRequestHeader('content-type', file.fileType)
            xhr.send(file)
            this.$refs.uploder.files.splice(this.$refs.uploder.files.indexOf(file), 1)
          } catch (err) {
            file.__inProgress = false
            file.__failed = true
            reject(xhr)
          }
        } else {
          file.__inProgress = false
          file.__failed = true
          file.__failedNoPassword = true
          reject(xhr)
        }
      })
    },
    isAllFilesDone() {
      return this.$refs.uploader.files.every(f => f.__doneUploading)
    },
    uploaded() {
      Utils.callSegmentTrack({ name: 'pp.records.uploaded' })
      this.$emit('uploadSuccess')
    },
    batchFailed() {
      this.$emit('uploadFailure')
    },
    fail() {
      this.$emit('uploadFailure')
    },
    passwordFailed() {
      this.$emit('uploadFailure')
    },
    aborted() {
      this.$emit('uploadAbort')
    },
    triggerFileSelect(type) {
      if (type === 'files') {
        this.$refs.uploader.$refs.file.click()
      } else if (type === 'folder') {
        this.$refs.uploader.$refs.folder.value = '' // this will reset existing folder selection in order to trigger change event
        this.$refs.uploader.$refs.folder.click()
      }
    },
    startUpload() {
      if (this.$refs.uploader.files.length && !this.isAllFilesDone()) {
        let files = this.$refs.uploader.files
        let fileNames = ''
        for (let file of files) {
          fileNames += ' ' + file.name
        }
        this.$refs.uploader.upload()
      }
    },
    abortUpload() {
      this.$refs.uploader.abort()
    }
  }
}
</script>

<style>
.document-upload {
  padding-top: 8px;
  padding-bottom: 16px;
}
.c-uploader-status-bar {
  background-color: white;
  font-size: 0.875rem;
  color: #4a4a4a;
}
.v-btn {
  text-transform: none !important;
}
</style>
